function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import "./ToggleButton.css"; // #region FONCTION COMPOSANT

/**
 * Un bouton à état (actif/inactif)
 * @class
 * @category Fields
 * @param {ToggleButton.propTypes} props
 */

function ToggleButton(props) {
  var colorOn = props.colorOn,
      colorOff = props.colorOff,
      onClick = props.onClick,
      state = props.state,
      style = props.style,
      text = props.text;

  var _useState = useState(state),
      active = _useState[0],
      setActive = _useState[1];

  var handleClick = function handleClick() {
    setActive(!active);

    if (onClick) {
      onClick(!active);
    }
  }; // On surveille l'état du bouton pour déclencher le rendu


  useEffect(function () {
    setActive(state);
  }, [state]);
  return /*#__PURE__*/React.createElement("button", {
    className: "ToggleButton",
    style: _extends({}, style, {
      backgroundColor: active ? colorOn : colorOff
    }),
    onClick: handleClick
  }, text);
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link ToggleButton}
 * @typedef {Object} ToggleButton.propTypes
 * @property {string} [colorOn=#f4432c] La couleur de fond du bouton dans son état actif
 * @property {string} [colorOff=#a8a8a8] La couleur de fond du bouton dans son état inactif
 * @property {function} onClick La fonction appelée à chaque clic
 * @property {boolean} [state=false] true pour passer à l'état actif
 * @property {object} [style] Un objet contenant le style à appliquer au bouton
 * @property {string} text Le libellé du bouton
 */


ToggleButton.propTypes = process.env.NODE_ENV !== "production" ? {
  colorOn: PropTypes.string,
  colorOff: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  state: PropTypes.bool,
  style: PropTypes.object,
  text: PropTypes.string.isRequired
} : {};
ToggleButton.defaultProps = {
  colorOn: "#83a697",
  colorOff: "#ededed",
  state: false,
  style: {}
}; // #endregion

export { ToggleButton };